// Which kind of thing a board ranks. A fact about the board rather than
// about the cell that draws it, and the cell file keeps to components.

import type { EntityKind, Leaderboard } from "./types";

/**
 * What a row of THIS board's top table is. Unlike the audit log, a score row's
 * kind is a property of the board: only scope=guild_aggregated ranks guilds
 * against each other, every other scope ranks players.
 */
export function entityKindOf(lb: Leaderboard): EntityKind {
  return lb.scope === "guild_aggregated" ? "guild" : "player";
}
